<script lang="ts">
  import ToggleCTA from "@kontextwerk/web-sdk/ui/actions/ToggleCTA.svelte"
  import SectionTitle from "@kontextwerk/web-sdk/ui/typography/SectionTitle.svelte"
  import type { CaseCommunicationFilterDisplayMode } from "../../../../../../../../_modules/case-communication-filter"

  type Props = {
    title?: string
    filterMode?: CaseCommunicationFilterDisplayMode
    helpModalTextId?: string
    onFilterModeChange?: (value: CaseCommunicationFilterDisplayMode) => void
  }

  let {
    title = "Terminkommunikation",
    filterMode = "compact",
    helpModalTextId = undefined,
    onFilterModeChange = () => {},
  }: Props = $props()

  const filterModeOptions: Array<{ value: CaseCommunicationFilterDisplayMode; label: string }> = [
    { value: "compact", label: "Kompakt" },
    { value: "detailed", label: "Ausführlich" },
  ]
</script>

<SectionTitle {title} {helpModalTextId} brightBackground={true}>
  {#snippet buttonSnippet()}
    <ToggleCTA
      options={filterModeOptions}
      value={filterMode}
      darkMode={false}
      onChange={(value) => {
        const nextValue = `${value ?? filterMode}`.toLowerCase()
        onFilterModeChange(nextValue === "detailed" ? "detailed" : "compact")
      }}
    />
  {/snippet}
</SectionTitle>
